import { LogoutOutlined, SettingsOutlined } from "@mui/icons-material";
import { ProfileMenuItem } from "components/organisms/Header";
import { QueryClientGlobal } from "configs";
import { confirm } from "contexts";
import store from "stores";
import { authSlice } from "stores/Auth";
import { systemSlice } from "stores/System";

export const ProfileMenu: Array<ProfileMenuItem> = [
  {
    id: "Account settings",
    label: "Account settings",
    icon: SettingsOutlined,
  },
  {
    id: "Logout",
    label: "Logout",
    icon: LogoutOutlined,
    onClick: () => {
      confirm({
        title: "Logout",
        content: "Do you want to logout?",
      }).then(() => {
        QueryClientGlobal?.clear();
        store.dispatch(authSlice.actions.logout());
        store.dispatch(systemSlice.actions.reset());
      });
    },
  },
];
